import { Injectable, signal } from '@angular/core';
import { Currency, PaymentDetails } from './general.model';

@Injectable({
  providedIn: 'root'
})
export class InstantBankTransferService {

  data = signal<any>({
    bankLocation: '',
    purpose: '',
    currency: Currency.GBP,
    sourceCurrency:Currency.GBP,
    targetCurrency:Currency.UGX,
    rate: 0,
    amount: 0,
    converted: 0,
    time: 'Up to 24 hours',
    cost: 0,
    quoteId: "",
    transactionId: "",
    bankRedirectUrl:""
  }
);

  constructor() { }
}
